import React, { useState } from "react";
import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import { api } from "../lib/api";
import { MagnifyingGlass, ArrowUpRight, User } from "@phosphor-icons/react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function Lookup() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const onSearch = async (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    setLoading(true);
    try {
      const { data } = await api.get(`/public/search`, { params: { q } });
      setResults(data.results || []);
      setSearched(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Nav />
      <section className="border-b border-black">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-14">
          <div className="label-tag">Public directory</div>
          <h1 className="font-display font-black text-4xl sm:text-6xl tracking-tighter mt-3">
            Find a Curb Crew.
          </h1>
          <p className="mt-4 text-neutral-700 max-w-xl">
            Search active Curb Crews by name, skill, location or code. Phone numbers are private — request contact from each profile.
          </p>yar 

          <form onSubmit={onSearch} className="mt-8 flex gap-0 border border-black" data-testid="lookup-form">
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="e.g. plumber, Thabo, Johannesburg"
              className="flex-1 px-4 py-4 text-base outline-none"
              data-testid="lookup-input"
            />
            <button
              type="submit"
              className="bg-black text-white label-tag px-6 flex items-center gap-2 hover:bg-[color:var(--cc-yellow)] hover:text-black transition-colors"
              data-testid="lookup-submit"
            >
              <MagnifyingGlass size={16} weight="bold" /> Search
            </button>
          </form>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-4 sm:px-6 py-10" data-testid="lookup-results">
        {loading && <div className="label-tag">Searching…</div>}
        {!loading && searched && results.length === 0 && (
          <div className="brutal-border p-8 bg-[color:var(--cc-bg-2)]">
            <div className="font-display font-black text-2xl">No results.</div>
            <p className="mt-2 text-neutral-700">Try a different skill or name.</p>
          </div>
        )}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {results.map((c) => (
            <Link
              key={c.id}
              to={`/c/${c.code}`}
              className="brutal-border bg-white block hover:brutal-shadow transition-all overflow-hidden"
              data-testid={`result-card-${c.code}`}
            >
              <div className="aspect-[4/3] bg-[color:var(--cc-bg-2)] grid place-items-center overflow-hidden border-b border-black">
                {c.picture_url ? (
                  <img src={`${BACKEND}${c.picture_url}`} alt={c.full_name} className="w-full h-full object-cover" />
                ) : (
                  <User size={48} weight="bold" className="text-neutral-400" />
                )}
              </div>
              <div className="p-5">
                <div className="flex items-start justify-between">
                  <div className="font-mono-cc text-xs text-neutral-500">#{c.code}</div>
                  <ArrowUpRight size={16} weight="bold" />
                </div>
                <div className="font-display font-black text-xl mt-3">{c.full_name}</div>
                {c.location && <div className="label-tag text-neutral-600 mt-1">{c.location}</div>}
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {(c.skills || []).slice(0, 4).map((s, i) => (
                    <span key={i} className="label-tag bg-[color:var(--cc-yellow)] px-2 py-1 border border-black">
                      {s}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
